import React from 'react';
import { Calendar, Plus, User, School,} from 'lucide-react';

const InscriptionHeader = ({ inscription, onNewPaymentClick }) => {
  if (!inscription) return null;

  const formatAmount = (amount) => {
    if (typeof amount !== 'number') return '0';
    return amount.toLocaleString();
  };

  return (
    <div className="bg-gradient-to-r from-[#202654] to-[#3a4999] text-white">
      {/* En-tête principal */}
      <div className="p-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center">
          {/* Informations de l'étudiant */}
          <div className="flex-1">
            <div className="flex items-center space-x-4">
              <div className="h-12 w-12 rounded-full bg-white/10 flex items-center justify-center">
                <User className="h-6 w-6 text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold">
                  {inscription.eleve?.prenom} {inscription.eleve?.nom}
                </h1>
                <div className="flex items-center mt-1 space-x-4">
                  <span className="flex items-center text-white/80">
                    <School className="h-4 w-4 mr-1" />
                    {inscription.filiere?.libelle} - {inscription.niveau?.libelle}
                  </span>
                  <span className="text-white/60">|</span>
                  <span className="flex items-center text-white/80">
                    <Calendar className="h-4 w-4 mr-1" />
                    {inscription.annee?.libelle}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="mt-4 lg:mt-0 flex items-center space-x-4">
            <div className="text-right mr-4">
              <p className="text-sm text-white/80">Montant total</p>
              <p className="text-xl font-bold">{formatAmount(inscription.montant_global)} FCFA</p>
            </div>
            <button
              onClick={onNewPaymentClick}
              className="inline-flex items-center px-4 py-2 bg-white text-[#202654] rounded-lg hover:bg-gray-100 transition-colors shadow-md"
            >
              <Plus className="h-5 w-5 mr-2" />
              Nouveau versement
            </button>
          </div>
        </div>
      </div>

      {/* Barre de progression */}
      <div className="bg-[#202654]/40 px-6 py-4">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex-1 w-full md:mr-8">
            <div className="flex justify-between text-sm mb-1">
              <span>Progression des paiements </span>
              <span className="font-semibold">{inscription.progression_paiement}%</span>
            </div>
            <div className="w-full bg-white/20 rounded-full h-2.5 overflow-hidden">
              <div
                className={`h-2.5 rounded-full transition-all duration-500 ${
                  inscription.progression_paiement >= 100 
                    ? 'bg-green-500' 
                    : inscription.progression_paiement >= 75 
                    ? 'bg-green-400' 
                    : inscription.progression_paiement >= 50 
                    ? 'bg-yellow-400' 
                    : inscription.progression_paiement >= 25 
                    ? 'bg-orange-400' 
                    : 'bg-red-500'
                }`}
                style={{ width: `${inscription.progression_paiement}%` }}
              />
            </div>
          </div>

          {/* Statistiques rapides */}
          <div className="flex space-x-6">
            <div className="text-center">
              <p className="text-sm text-white/80">Payé</p>
              <p className="text-lg font-semibold text-green-400">
                {formatAmount(Number(inscription.montant_paye) + Number(inscription.montant_options_paye))} FCFA
              </p>
            </div>
            <div className="text-center">
              <p className="text-sm text-white/80">Reste à payer</p>
              <p className="text-lg font-semibold text-red-400">
                {formatAmount(Number(inscription.montant_impaye) + Number(inscription.montant_options_impaye) )} FCFA
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InscriptionHeader;
